import React, { Component } from 'react';
import Masthead from '@ta-interaktiv/react-masthead';
import Scoreboard from './Scoreboard';
import Inlinescore from './Inlinescore';
import Pronocard from './Pronocard';

import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import PolymorphicShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import { Tracking } from '@ta-interaktiv/react-tracking'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'

import './App.css';
import './videoWrapper.css'

const posterImage = require('./images/header.jpg')


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTemplate: 0
    };
  }

  componentDidMount(){
      //console.log( PlayersDb )
  }

  render() {
    return (
      <div className={"app style-" + this.state.currentTemplate}>
        <Masthead
          enablePaywall={false}
          inverted={true}
          articleId='16143019' />

        <div
         className='cover'
         style={{
           backgroundColor: '#333',
           backgroundImage: `url(${posterImage})`,
           height: '100vh'
           }}
         >

           <div
             className='top gradient'
             style={{
               background: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))`
             }}
           />

         <main id="section-1" className='ui vertical very fitted inverted segment text-chapter'>
           <div className="downbait"></div>
           <div className='ui container'>
             <div className='ui text container no-marg aligned center' style={{textAlign: "center"}}>
               <img className="ui fluid image section-stars" src={require("./images/stars_colorized.png")} alt="" />
               <h1>Vom verrücktesten Spiel bis zum schönsten Tor</h1>
               <p className="ta lead">
                 Alle Fakten und Zahlen zur Schweiz und ihren Fussball-WM-Teilnahmen.
               </p>
             </div>
           </div>
         </main>

       </div>

          <main id="section-2" className='ui vertical very fitted segment text-chapter'>
            <div className='ui container'>
              <div className='ui text container no-marg'>
                <div className="authors"><b>Renaud Tschoumy, Frédéric Thomasset, Mathieu Rudaz und Interaktiv-Team</b></div>
                <p>
                  Erinnern Sie sich an jedes WM-Trikot der Schweizer? An die torreichsten Spiele und die bittersten Niederlagen? Vor dem Start der WM in Russland wollen wir die Geschichte der Schweizer Nationalmannschaft auf eine andere Art erzählen und Revue passieren lassen. Die Analyse basiert auf Daten eines ganzen Fussball-Jahrhunderts.</p>
                  <p>
                    <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
                  </p>
              </div>
            </div>
            <div className='ui container stat-bloc'>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">1</div>
                  <h2>Der typische Spieler</h2>
                </div>
                <p>
                  Anhand von statistischen Daten haben wir die Merkmale des typischen Schweizer Nationalspielers errechnet. Wenn Ihre Eltern aus Zürich stammen, Ihr Familienname Müller ist und Sie Walter gerufen werden, hätten Sie die besten Chancen gehabt, in das Team berufen zu werden.
                </p>
                <img className="ui fluid image" src={require("./images/joueur-03.svg")} alt="" />
                <p>
                  Walter und Müller sind mit Abstand die häufigsten Vor- und Nachnamen in der Spielergeschichte der Schweizer Nationalmannschaft. Fügt man dem eine Grösse von 180 cm und eine Spielerlizenz von GC hinzu, ergibt das den Standard-Nationalspieler.
                </p>
              </div>
            </div>

            <div className='ui container stat-bloc'>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">2</div>
                  <h2>Die Endrunden</h2>
                </div>
                <p>
                  In diesem Jahr nimmt die Schweiz zum elften Mal an einer WM-Endrunde teil. Während sie die Qualifikation für die WM 1930 verpasste, sicherte sie sich die Teilnahme an sechs der sieben folgenden Turniere (Italien 1934, Frankreich 1938, Brasilien 1950, Schweiz 1954 als Gastgeberland, Chile 1962, England 1966).
                </p>

                <p>
                  Darauf folgte eine lange Durststrecke von 28 Jahren beziehungsweise sechs Endrunden, die erst mit der Qualifikation für die WM 1994 in den USA unter Trainer Roy Hodgson endete.
                </p>

              </div>
            </div>

            <div className='ui text container'>
              <img className="ui fluid image" src={require("./images/dataviz_participations-desktop.svg")} alt="" />
            </div>

            <div className='ui container'>
              <div className='ui text container no-marg'>

                <p>
                  Nach der verpassten Teilnahme an den Weltmeisterschaften in Frankreich (1998) und in Japan und Südkorea (2002) qualifizierte sich die Schweiz für alle folgenden Endrunden (Deutschland 2006, Südafrika 2010, Brasilien 2014, Russland 2018).
                </p>
              </div>
            </div>

            <div className='ui container stat-bloc pronocards-container'>
              <div className='ui text container no-marg' style={{position:"relative"}}>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small inverted">3</div>
                  <h2>1934: Das erste WM-Spiel</h2>
                </div>

                <p>
                  Mit einem Unentschieden gegen Jugoslawien und einem Forfaitsieg gegen Rumänien – aufgrund eines nicht spielberechtigten Spielers in der Aufstellung – qualifizierte sich die Schweiz für die WM und bestritt ihr erstes Endrundenspiel am 27. Mai 1934 in Mailand gegen die Niederlande.
                </p>

                <Scoreboard score={[3,2]} teams={["Schweiz", "Niederlande"]}/>

                <aside className='ui right rail computer or lower hidden' style={{top: '30%'}}>
                    <div className='story-hint quote'>
                      <div className='hint-container'>
                        <div>
                          <p>
                            Trello Abegglen zieht alle Register. Nach zwei von Kielholz verwerteten Vorlagen trifft er selbst zum 3:1.
                          </p>
                        </div>
                      </div>
                    </div>
                </aside>

                <p>
                  Da die damalige WM aus einem Turnier zwischen 16 Mannschaften bestand, entsprach die erste Runde dem Achtelfinal. Auf den Rängen haben die Niederländer die Oberhand (7000 mitgereiste Fans gegenüber 2000 Schweizern), auf dem Feld müssen sie sich der Schweizer Nationalmannschaft geschlagen geben.
                </p>
                <p>
                  An jenem Tag zieht Trello Abegglen alle Register. Zuerst liefert er zwei präzise Traumvorlagen, die Kielholz in der 7. und 44. Minute verwertet. In der 72. Minute trifft er selbst und sichert mit seinem Tor den Schweizer Sieg. Nach dem <Inlinescore className="score" score={[3,2]} /> gegen die Niederlande zieht die Nationalmannschaft in die Viertelfinals ein und unterliegt dort den zukünftigen Finalisten aus der Tschechoslowakei mit <Inlinescore className="score" score={[2,3]} />.
                </p>
              </div>
            </div>

            <div className='ui container stat-bloc' style={{borderTop: "none"}}>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">4</div>
                  <h2>Die grössten Erfolge</h2>
                </div>
                <p>
                  Die Schweiz hat bisher dreimal die Viertelfinals erreicht – allerdings zu einer Zeit, in der die WM-Endrunde zwischen nur 16 Mannschaften entschieden wurde. Die Viertelfinal-Qualifikation war also bedeutend einfacher. Seit der Erweiterung des Turniers auf 24 und später auf 32 Mannschaften konnte die Nationalmannschaft nie mehr an den Viertelfinals teilnehmen.
                </p>

                <img className="ui fluid image" src={require("./images/dataviz_results.svg")} alt="" />

                <p>
                  Seit ihrer Rückkehr an die Weltspitze gelang der Nationalmannschaft dreimal die Achtelfinal-Teilnahme. 1994 fertigte Spanien die Schweiz in Washington mit <Inlinescore className="score" score={[0,3]} /> ab. Nach dem <Inlinescore className="score" score={[0,0]} /> nach 120 Minuten gegen die Ukraine flog die Schweiz 2006 nach dem Penaltyschiessen aus dem Turnier. Marco Streller, Tranquillo Barnetta und Ricardo Cabanas blieben am Elfmeterpunkt erfolglos. 2014 zwang die Nationalmannschaft Lionel Messis Argentinien in die Verlängerung, verlor die Partie jedoch nach dem <Inlinescore className="score" score={[1,0]} /> durch Di Maria in der 118. Minute und Dzemailis Kopfball an den Torpfosten in der 120. Minute.
                </p>
              </div>
            </div>

            <div className='ui container stat-bloc'>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">5</div>
                  <h2>Die Statistik</h2>
                </div>
                <p>
                  Die Schweizer Nationalmannschaft hat bisher 33 Spiele in einer WM-Endphase bestritten. Ihre globale Bilanz ist negativ: 11 Siege stehen 6 Unentschieden und 16 Niederlagen gegenüber, und das bei einem Torverhältnis von –14 (45 geschossen, 59 erhalten).
                </p>
                <p>
                  Die Schweiz hat dreimal mit einem Vorsprung von drei Toren gewonnen: Das erste Mal erzielte die Nationalmannschaft im Jahr 1954 ein <Inlinescore className="score" score={[4,1]} /> gegen Italien, 1994 erkämpfte sie ebenfalls ein <Inlinescore className="score" score={[4,1]} /> gegen Rumänien, und zuletzt gewann sie im Jahr 2014 <Inlinescore className="score" score={[3,0]} /> gegen Honduras.
                </p>
                <p>
                  Umgekehrt musste die Nationalmannschaft schon eine Niederlage mit 5 Toren Unterschied (<Inlinescore className="score" score={[0,5]} /> gegen Deutschland im Jahr 1966) sowie vier Niederlagen mit 3 Toren Unterschied hinnehmen: 1950 unterlag die Schweiz Jugoslawien mit <Inlinescore className="score" score={[0,3]} />, ebenso im Jahr 1962 gegen Italien und 1994 gegen Spanien. 2014 bezwang Frankreich die Nationalmannschaft mit <Inlinescore className="score" score={[2,5]} />.
                </p>

                <img className="ui fluid image" src={require("./images/dataviz_stats.svg")} alt="" />

                <p>
                  Die meisten Tore erzielte die Schweiz im berühmten Viertelfinal gegen Österreich an der WM 1954: Fünfmal jagte die Nationalmannschaft den Ball ins gegnerische Netz – und musste sich dem Nachbarland dennoch mit <Inlinescore className="score" score={[5,7]} /> geschlagen geben.
                </p>
                <p>
                  Auf den ersten WM-Match ohne Gegentor musste die Schweiz bis ins Jahr 2006 warten: In Deutschland erreichte die Nationalmannschaft im insgesamt 23. Endrundenspiel ein <Inlinescore className="score" score={[0,0]} /> gegen Frankreich. Daraus entwickelte sich eine Nullerserie mit dem folgenden <Inlinescore className="score" score={[2,0]} /> gegen Togo, dem <Inlinescore className="score" score={[2,0]} /> gegen Südkorea und dem <Inlinescore className="score" score={[0,0]} /> gegen die Ukraine im Achtelfinal.
                </p>
                <p>
                  Der beste Schweizer Torschütze an einer WM-Endphase ist mit 6 erzielten Toren Sepp Hügi, gefolgt von André Abegglen und Robert Ballaman mit je 4 erfolgreichen Abschlüssen. Jacky Fatton, Leopold Kielholz und Xherdan Shaqiri liegen mit je 3 Toren auf Rang 3. Alex Frei und Adrian Knup trafen beide zweimal. Weitere 18 Spieler schossen je ein Tor.
                </p>
                <p>
                  Die einzigen Schweizer Spieler, die in einer WM-Endphase mit einem Hattrick glänzen konnten, sind Sepp Hügi (bei der <Inlinescore className="score" score={[5,7]} />-Niederlage gegen Österreich an der WM 1954) und Xherdan Shaqiri (beim <Inlinescore className="score" score={[3,0]} />-Sieg gegen Honduras vor vier Jahren).
                </p>
              </div>
            </div>

            <div className='ui container stat-bloc'>
              <div className='ui text container no-marg' style={{position:"relative"}}>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">6</div>
                  <h2>1954: Das verrückteste Spiel</h2>
                </div>
                {/*<div className="dateyear">1954</div>*/}
                <p>
                  Das verrückteste Spiel der Schweizer Nationalmannschaft ist zweifellos der berühmt-berüchtigte Viertelfinal gegen Österreich vom 26. Juni 1954 in Lausanne: Vor den 35 000 Zuschauern in der ausverkauften Pontaise schiesst die Schweiz drei Tore innerhalb von drei Minuten.
                </p>
                <p>
                  Dank dem Treffer von Ballaman und Hügis Doppelschlag führt die Nationalmannschaft nach 19 Minuten <Inlinescore className="score" score={[3,0]} />. Doch dann erleidet der Abwehrchef Bocquet eine Gehirnerschütterung. Völlig benebelt kann er die Verteidigung nicht mehr organisieren, und Torhüter Parlier muss es alleine mit zwei österreichischen Stürmern aufnehmen.
                </p>
                {/*<Scoreboard score={[7,5]} teams={["Autriche", "Suisse"]} />*/}

                <aside className='ui right rail computer or lower hidden' style={{top: '50%'}}>
                    <div className='story-hint quote'>
                      <div className='hint-container'>
                        <div>
                          <p>
                            Dann erleidet Bocquet eine Gehirnerschütterung. Völlig benebelt kann er die Verteidigung nicht mehr organisieren. Sein Torhüter Parlier ist auf sich allein gestellt.
                          </p>
                        </div>
                      </div>
                    </div>
                </aside>

                <img className="ui fluid image" src={require("./images/match-1954.jpg")} style={{margin: "20px 0px 30px 0px"}} alt="" />

                <p>
                  In nur neun Minuten – zwischen der 25. und 34. – trifft Österreich fünfmal und stellt das Spiel auf den Kopf. Ballaman erzielt in der 39. Minute den Anschlusstreffer zum Pausenstand von <Inlinescore className="score" score={[4,5]} />, und Hügi komplettiert in der 60. Minute seinen Hattrick, aber die Schweiz kann das Ruder nicht mehr herumreissen.
                </p>

                <p>
                  Österreich bezwingt schliesslich die Nationalmannschaft mit <Inlinescore className="score" score={[7,5]} />, der Traum von der Halbfinalteilnahme im eigenen Land platzt. Dieses legendäre Spiel hält im Übrigen bis heute den Rekord für die meisten geschossenen Tore in einem einzigen WM-Spiel.
                </p>
              </div>
            </div>
          </main>

          <main id="section-3" className='ui vertical very fitted segment text-chapter yellow-bg'>
            <div className='ui container goal-text'>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small inverted">7</div>
                  <h2>Das schönste Tor</h2>
                </div>
                <p>
                  Unsere subjektive Wahl fiel auf Haris Seferovics Treffer gegen Ecuador im Schweizer Auftaktspiel an der WM 2014 in Brasilien (<Inlinescore className="score" score={[2,1]} /> in der 93. Minute).
                </p>
              </div>
            </div>

            <div className='ui container goal-video'>
              <div className='videoWrapper' style={{marginTop: "20px"}}>
                    <iframe
                      className='externalNNIFrame'
                      src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@342088|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@https://server025.newsnetz.tv/342088/frame-28-342088.jpg|platform@desktop'
                      allowFullScreen='true'
                      scrolling='no'
                      frameBorder='no'
                      title='Michel Pont video'
                    />
              </div>
            </div>
          </main>

          <main id="section-4" className='ui vertical very fitted segment text-chapter'>
            <div className='ui container stat-bloc'>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">8</div>
                  <h2>Das Trikot im Verlauf der Zeit</h2>
                </div>
                <p>
                  Ein weisses Kreuz auf rotem Grund: Das Design der Trikots scheint auf der Hand zu liegen. Trotzdem gab es verschiedene Ausnahmen.
                </p>
                <p>
                  1990 ist die Nationalmannschaft unter Vertrag mit der Textilfirma Blacky, die ein neues Design einführt. Das Schweizer Kreuz nimmt beinahe die ganze Trikotfront ein und ist mit schwarzen Linien von der roten Grundfarbe abgegrenzt. Der Skandal ist perfekt: Wie kann man nur ohne das – im Übrigen entstellte – Landessymbol über dem Herzen für die Schweiz auflaufen? Ironischerweise gelingen der Schweizer Nationalmannschaft gerade in diesem Trikot (und natürlich mit Chapuisat, Knup etc.) die ersten Glanzleistungen der jüngeren Vergangenheit. Die WM 1994 in den USA bestreitet die Nationalmannschaft dann aber in einem Leibchen von Lotto. Ab 1998 werden die Spieler von Puma eingekleidet.
                </p>

                <img className="ui fluid image" src={require("./images/dataviz_maillots.svg")} alt="" />

                <p>
                  2008, kurz vor der Europameisterschaft in der Schweiz und Österreich, löst Puma mit der Präsentation des neuen Trikots eine Kontroverse aus: Das Schweizer Kreuz wird nur vom SFV-Logo angedeutet und sorgt für Kritik durch dessen «mangelnde Sichtbarkeit». Die Nationalmannschaft bestreitet «ihr» Turnier trotz aller Polemik in diesen Leibchen.
                </p>
                <p>
                  Für die WM in Südafrika wird die Schweizer Fahne wieder über dem Herz platziert. Das Verbandslogo rutscht auf die rechte Seite des Trikots. Wer vom Schweizer Nationaldress spricht, kommt um eine Episode nicht herum: Am 19. Juni 2016, beim letzen EM-Gruppenspiel gegen Frankreich, reissen die Leibchen von Mehmedi, Embolo, Dzemaili und Xhaka. Für einmal gab also nicht das Design zu reden, sondern die schlechte Verarbeitung. Am folgenden Tag räumte Puma einen Fabrikationsfehler ein.
                </p>
              </div>
            </div>

            <div className='ui container stat-bloc'>
              <div className='ui text container no-marg'>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small">9</div>
                  <h2>Das Geld</h2>
                </div>
                <p>
                  Im Vergleich zur letzen Weltmeisterschaft in Brasilien vor vier Jahren hat die Fifa die verfügbare Preisgeldsumme bedeutend aufgestockt. In Russland werden insgesamt 400 Millionen Dollar an die 32 Teilnehmerländer verteilt, was einem Wachstum von 12 Prozent gegenüber den 358 Millionen von 2014 entspricht.
                </p>
              {/*<p>
                  Chaque pays qualifié recevra une prime de 8 millions de dollars. Les huitièmes
                  de finalistes toucheront 9 millions de dollars, les quarts de finalistes 14 millions,
                  le quatrième 20 millions, le troisième 22 millions, le finaliste 25 millions et le
                  champion du monde 35 millions.
                  En plus de ces sommes qui seront donc allouées aux Fédérations en fonction de
                  leur parcours en Russie, la FIFA a d’ores et déjà dédommagé les équipes
                  qualifiées pour leur frais de préparation, à hauteur de 1,5 million de dollars par
                  nation.
                </p>*/}

                <img className="ui fluid image" src={require("./images/dataviz_argent.svg")} alt="" />

                <p>
                  Über diese an die Verbände ausgeschütteten Summen hinaus erhält jede qualifizierte Mannschaft eine Vorbereitungsentschädigung in der Höhe von 1,5 Millionen Dollar von der Fifa.
                </p>
                <p>
                  Die Hotel- und Transportkosten in Russland werden bis zu einer Anzahl von 50 Personen vollumfänglich von der Fifa übernommen. Der Schweiz bezahlt die Fifa den Flug von Zürich nach Samara (nächstliegender Flughafen vom Basiscamp in Tolyatti aus) und zurück, die Transfers zu den Städten, in welchen die Nationalmannschaft Spiele bestreitet, und natürlich alle Übernachtungen des Aufenthalts.
                </p>
                <p>
                  Die Delegation des Schweizer Fussballverbands (SFV) besteht aus insgesamt 55 Personen: Die 23 Spieler werden von 32 Mitarbeitern und Verbandsvertretern – darunter Köche, PR-Verantwortliche, Videoanalysten und Funktionäre – begleitet, die sich um deren physisches und psychisches Wohl sowie um organisatorische und technische Belange kümmern. Der SFV muss für die von den fünf überzähligen Personen verursachten Kosten aufkommen. Auch für die Versorgung von allfälligen weiteren geladenen Gästen ist der Verband selbst zuständig.
                </p>
              </div>
            </div>

            <div className='ui container pronocards-container' style={{textAlign: "center"}}>

              <div className='ui text container no-marg' style={{textAlign: "left"}}>
                <div className="title-bloc" style={{textAlign: "center"}}>
                  <div className="section-number small inverted">10</div>
                  <h2>Die Prognose</h2>
                </div>
                <p>
                  In den Augen der Sportexperten der Tamedia-Redaktion ist Deutschland Favorit auf den Titel.
                </p>
                <p>
                  Von 18 befragten Redaktoren glauben sechs, dass unsere deutschen Nachbarn den Weltmeistertitel in Russland verteidigen können. Frankreich wurde mit vier Stimmen am zweitmeisten genannt.
                </p>
                <p>
                  Die Teams aus Brasilien, Spanien, Argentinien und England wurden jeweils von zwei Experten favorisiert.
                </p>
              </div>

              <div style={{marginTop: "60px"}}><span className="special">Tippen Sie die Karten an, um sie zu drehen.</span></div>
              <Pronocard title="Die Mathematiker" candidates={["Brasilien", "Deutschland", "Argentinien", "Spanien", "Belgien"]} switzerland="1,4%" source="Sportstatistik: Opta"/>
              <Pronocard title="Die Buchmacher" candidates={["Deutschland", "Frankreich", "Spanien", "Brasilien", "Argentinien"]} switzerland="26" source="Durchschnittliche Gewinnchancen auf 8 Online-Sportwettseiten"/>
              <Pronocard title="Unsere Journalisten" candidates={["Deutschland", "Frankreich"]} switzerland="16" source="Tamedia Sportredaktion"/>
              <Pronocard title="Die Gamer" candidates={["Belgien", "Frankreich", "Brasilien", "Spanien", "Deutschland"]} switzerland="0 fois" source="Fussball Manager 2018: von 100 simulierten Weltmeisterschaften"/>
              <Pronocard title="Die Ziege" candidates={["Belgien", "Frankreich"]} switzerland="" source="Die russische Ziege Zabiyaka im Zoo in Samara"/>
            </div>

            <div className='ui container sources'>
              <div className='ui text container no-marg'>
                <h5>Quellen</h5>
                <p>
                  transfermarkt.com, fifa.com, Schweizerischer Fussballverband (SFV), national-football-teams.com
                </p>
              </div>
            </div>
          </main>

        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable grid'>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small infographic table'>
                    <tbody>
                      <tr>
                        <td>Text</td>
                        <td>Renaud Tschoumy, Daniel Visentini</td>
                      </tr>
                      <tr>
                        <td>Übersetzung</td>
                        <td>Fabienne Romanens</td>
                      </tr>
                      <tr>
                        <td>Visuelles Konzept und Illustration</td>
                        <td>
                          Mathieu Rudaz
                        </td>
                      </tr>
                      <tr>
                        <td>Adaption</td>
                        <td>
                          Dino Caracciolo, Mathias Lutz
                        </td>
                      </tr>
                      <tr>
                        <td>Publiziert</td>
                        <td>
                          <TimestampFormatter timestamp={1528790640 - 14400} />
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
                  <div className='ui fluid share center aligned container'>
                    <PolymorphicShareButtons articleID='16143019' />
                  </div>
                  <Tracking articleId='16143019' />
                </div>
              </div>
            </div>
          </div>
        </footer>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js